import { render, staticRenderFns } from "./Structure.vue?vue&type=template&id=4523fc5c&scoped=true&"
import script from "./Structure.vue?vue&type=script&lang=js&"
export * from "./Structure.vue?vue&type=script&lang=js&"
import style0 from "./Structure.vue?vue&type=style&index=0&id=4523fc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4523fc5c",
  null
  
)

export default component.exports